import React from 'react';
import ChannelTalkDescription from './ChannelTalkDescription';

const NoticeBeforeCertification = () => (
  <ChannelTalkDescription>
    <div>
      <p>본인인증을 진행한 아이디만 찾을 수 있습니다.</p>
      <p>본인인증을 진행한 적이 없다면 휴대전화번호와 함께 1:1 채팅상담으로 문의해주세요</p>
    </div>
  </ChannelTalkDescription>
);

export default NoticeBeforeCertification;
